const chapter = {
  id: 'fluid-dynamics',
  slug: 'fluid-dynamics',
  subject: 'physics',
  subjectLabel: 'Physics',
  exam: 'JEE / NEET',
  title: {
    english: 'Fluid Mechanics & Dynamics',
        hindi: 'द्रव यांत्रिकी और गतिकी',
  },
  estReadMinutes: 50,
  difficulty: {
    english: 'Medium',
        hindi: 'मध्यम',
  },
  weightage: {
    english: '1-2 questions in JEE / NEET',
        hindi: 'जेईई/नीट में 1-2 प्रश्न **पास्कल का नियम:** बंद तरल पदार्थ पर लगाया गया दबाव सभी भागों में बिना कम हुए प्रसारित होता है। हाइड्रोलिक प्रेस का आधार: ।',
  },
  syllabusTags: ['Mechanics of fluids', 'Class-11', 'JEE Main', 'NEET'],
  sections: [
    {
      id: 'fluid-statics',
      title: {
        english: 'Fluid Statics — Pressure & Pascal',
        hindi: 'द्रव स्थैतिकी — दाब और पास्कल',
      },
      blocks: [
        {
          type: 'equation',
          equation: 'P = \\dfrac{F_\\perp}{A}, \\quad [P] = \\text{Pa} = \\text{N/m}^2',
        },
        {
          type: 'equation',
          equation: 'P = P_0 + \\rho g h \\quad \\text{(hydrostatic; depth } h\\text{)}',
        },
        {
          type: 'list',
          items: [
            {
              english: '**Pascal\'s law:** pressure applied to enclosed fluid is transmitted undiminished to all parts. Basis of hydraulic press: $F_2 = F_1 \\cdot A_2 / A_1$.',
        hindi: '**पास्कल का नियम:** बंद तरल पदार्थ पर लगाया गया दबाव सभी भागों में बिना कम हुए प्रसारित होता है। हाइड्रोलिक प्रेस का आधार: $F_2 = F_1 \\cdot A_2 / A_1$।',
            },
            {
              english: 'Atmospheric pressure $P_0 = 1.013 \\times 10^5$ Pa $\\approx 76$ cm of Hg.',
        hindi: 'वायुमंडलीय दबाव $P_0 = 1.013 \\times 10^5$ Pa $\\approx 76$ सेमी Hg।',
            },
            {
              english: 'Gauge pressure = absolute - atmospheric.',
        hindi: 'गेज pressure = absolute - atmospheric। दबाव केवल गहराई पर निर्भर करता है (आकार पर नहीं) - हाइड्रोस्टैटिक विरोधाभास।',
            },
            {
              english: 'Pressure depends only on depth (not shape) — hydrostatic paradox.',
        hindi: 'दबाव केवल गहराई पर निर्भर करता है (आकार पर नहीं) - हाइड्रोस्टेटिक विरोधाभास।',
            },
          ],
        },
      ],
    },
    {
      id: 'archimedes',
      title: {
        english: 'Archimedes\' Principle & Buoyancy',
        hindi: 'आर्किमिडीज़ का सिद्धान्त और उत्प्लावन',
      },
      blocks: [
        {
          type: 'definition',
          title: {
            english: 'Buoyancy',
        hindi: 'उछाल',
          },
          body: {
            english: 'A body fully or partially immersed in a fluid experiences an upward force equal to the weight of fluid displaced: $F_B = \\rho_{fluid} V_{disp} g$.',
        hindi: 'किसी तरल पदार्थ में पूरी तरह या आंशिक रूप से डूबा हुआ शरीर विस्थापित तरल के वजन के बराबर ऊपर की ओर बल का अनुभव करता है: $F_B = \\rho_{fluid} V_{disp} g$। **फ्लोटिंग स्थिति:** का वजन, यानी $F_B = \\rho_{fluid} V_{disp} g$।',
          },
        },
        {
          type: 'list',
          items: [
            {
              english: '**Floating condition:** weight of body = weight of fluid displaced, i.e. $\\rho_{body} V_{body} = \\rho_{fluid} V_{disp}$.',
        hindi: '**तैरने की स्थिति:** शरीर का वजन = विस्थापित द्रव का वजन, यानी $\\rho_{body} V_{body} = \\rho_{fluid} V_{disp}$.',
            },
            {
              english: 'Fraction submerged $= \\rho_{body}/\\rho_{fluid}$.',
        hindi: 'अंश जलमग्न $= \\rho_{body}/\\rho_{fluid}$.',
            },
            {
              english: 'Apparent weight $= W - F_B = V g (\\rho_{body} - \\rho_{fluid})$.',
        hindi: 'स्पष्ट वजन $= W - F_B = V g (\\rho_{body} - \\rho_{fluid})$.',
            },
          ],
        },
        {
          type: 'example',
          problem: {
            english: 'Iceberg floats in sea water with density $\\rho_{ice} = 0.9 \\rho_{sea}$. Fraction visible above water?',
        hindi: 'हिमखंड $\\rho_{ice} = 0.9 \\rho_{sea}$ घनत्व के साथ समुद्र के पानी में तैरता है। पानी के ऊपर दिखाई दे रहा अंश?',
          },
          solution: {
            english: 'Submerged fraction $= 0.9$ → visible $= 0.1 = 10\\%$.',
        hindi: 'डूबा हुआ अंश $= 0.9$ → दृश्यमान $= 0.1 = 10\\\\%$।',
          },
        },
      ],
    },
    {
      id: 'continuity',
      title: {
        english: 'Equation of Continuity',
        hindi: 'सातत्य का समीकरण',
      },
      blocks: [
        {
          type: 'paragraph',
          body: {
            english: 'For incompressible, steady flow: mass flux is constant along a streamline.',
        hindi: 'असम्पीडित, स्थिर प्रवाह के लिए: एक स्ट्रीमलाइन के साथ द्रव्यमान प्रवाह स्थिर होता है।',
          },
        },
        {
          type: 'equation',
          equation: 'A_1 v_1 = A_2 v_2 = \\text{const} \\quad \\text{(volume flow rate)}',
        },
        {
          type: 'note',
          body: {
            english: 'Narrower section → higher velocity. (Why a thinning water stream from a tap.)',
        hindi: 'संकीर्ण खंड → उच्च वेग। (नल से पानी की पतली धारा क्यों आती है।)',
          },
        },
      ],
    },
    {
      id: 'bernoulli',
      title: {
        english: 'Bernoulli\'s Theorem',
        hindi: 'बर्नूली का प्रमेय',
      },
      blocks: [
        {
          type: 'paragraph',
          body: {
            english: 'For ideal (incompressible, non-viscous) steady flow along a streamline, total mechanical energy per unit volume is conserved:',
        hindi: 'एक स्ट्रीमलाइन के साथ आदर्श (असंपीड़ित, गैर-चिपचिपा) स्थिर प्रवाह के लिए, प्रति इकाई आयतन कुल यांत्रिक ऊर्जा संरक्षित है:',
          },
        },
        {
          type: 'equation',
          equation: 'P + \\dfrac{1}{2} \\rho v^2 + \\rho g h = \\text{constant}',
        },
        {
          type: 'list',
          items: [
            {
              english: '$P/\\rho g$ — pressure head; $v^2/(2g)$ — velocity head; $h$ — elevation head.',
        hindi: '$P/\\rho g$ - दबाव सिर; $v^2/(2g)$ - वेग शीर्ष; $h$ - ऊंचाई वाला सिर।',
            },
            {
              english: 'High velocity ↔ low pressure (basis of aerofoil lift, atomiser, Bunsen burner, Magnus effect).',
        hindi: 'उच्च वेग ↔ निम्न दबाव (एयरोफ़ोइल लिफ्ट, एटमाइज़र, बन्सेन बर्नर, मैग्नस प्रभाव का आधार)। **टोरिसेली का प्रमेय:** एक बड़े खुले टैंक में पानी की सतह के नीचे गहराई पर एक छोटे छेद से प्रवाह की गति। शीर्ष (बड़े क्षेत्र, ) और छेद (): के बीच बर्नौली लगाएं।',
            },
          ],
        },
        {
          type: 'example',
          problem: {
            english: '**Torricelli\'s theorem:** Speed of efflux from a small hole at depth $h$ below water surface in a large open tank.',
        hindi: '**टोरिसेली का प्रमेय:** एक बड़े खुले टैंक में पानी की सतह के नीचे $h$ गहराई पर एक छोटे छेद से प्रवाह की गति।',
          },
          solution: {
            english: 'Apply Bernoulli between top (large area, $v \\approx 0$, $P_0$) and hole ($P_0$): $P_0 + \\rho g h = P_0 + \\frac{1}{2}\\rho v^2 \\Rightarrow v = \\sqrt{2gh}$.',
        hindi: 'शीर्ष (बड़े क्षेत्र, $v \\approx 0$, $P_0$) और छेद ($P_0$): $P_0 + \\rho g h = P_0 + \\frac{1}{2}\\rho v^2 \\Rightarrow v = \\sqrt{2gh}$ के बीच बर्नौली लगाएं।',
          },
        },
        {
          type: 'example',
          problem: {
            english: 'Venturi meter: pressure difference $\\Delta P$ between wide ($A_1$) and narrow ($A_2$) sections gives flow speed.',
        hindi: 'वेंचुरी मीटर: चौड़े ($A_1$) और संकीर्ण ($A_2$) खंडों के बीच दबाव अंतर $\\Delta P$ प्रवाह गति देता है।',
          },
          solution: {
            english: '$v_1 = A_2 \\sqrt{\\dfrac{2\\Delta P}{\\rho(A_1^2 - A_2^2)}}$.',
        hindi: '$v_1 = A_2 \\sqrt{\\dfrac{2\\Delta P}{\\rho(A_1^2 - A_2^2)}}$.',
          },
        },
      ],
    },
    {
      id: 'viscosity',
      title: {
        english: 'Viscosity & Stokes\' Law',
        hindi: 'श्यानता और स्टोक्स का नियम',
      },
      blocks: [
        {
          type: 'definition',
          title: {
            english: 'Coefficient of viscosity',
        hindi: 'चिपचिपाहट का गुणांक',
          },
          body: {
            english: 'For laminar flow with velocity gradient $dv/dy$: shear stress $F/A = \\eta\\,dv/dy$. SI unit: Pa·s (or poiseuille). CGS: poise = $0.1$ Pa·s.',
        hindi: 'वेग प्रवणता $dv/dy$ के साथ लामिना प्रवाह के लिए: कतरनी तनाव $F/A = \\eta\\,dv/dy$। एसआई इकाई: Pa·s (या poiseuille)। सीजीएस: poise = Pa·s.',
          },
        },
        {
          type: 'equation',
          equation: 'F = 6\\pi \\eta r v \\quad \\text{(Stokes drag on small sphere)}',
        },
        {
          type: 'equation',
          equation: 'v_t = \\dfrac{2 r^2 (\\rho - \\sigma) g}{9\\eta} \\quad \\text{(terminal velocity in fluid of density } \\sigma\\text{)}',
        },
        {
          type: 'note',
          body: {
            english: 'Reynolds number $Re = \\rho v d / \\eta$ decides flow regime: $Re < 2000$ laminar; $> 3000$ turbulent.',
        hindi: 'रेनॉल्ड्स संख्या $Re = \\rho v d / \\eta$ प्रवाह व्यवस्था तय करती है: $Re < 2000$ लैमिनर; $> 3000$ अशांत।',
          },
        },
      ],
    },
    {
      id: 'surface-tension',
      title: {
        english: 'Surface Tension & Capillarity',
        hindi: 'पृष्ठ तनाव और केशिकत्व',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Surface tension** $T$ = force per unit length acting tangential to free surface (N/m). Equivalent: surface energy per unit area (J/m²).',
        hindi: '**सतह तनाव** $T$ = प्रति इकाई लंबाई पर मुक्त सतह पर स्पर्शरेखीय कार्य करने वाला बल (N/m)। समतुल्य: प्रति इकाई क्षेत्र सतह ऊर्जा (J/m²)।',
            },
            {
              english: 'Excess pressure inside drop: $P = 2T/R$. Inside soap bubble (two surfaces): $P = 4T/R$. Inside air bubble in liquid: $P = 2T/R$.',
        hindi: 'ड्रॉप के अंदर अतिरिक्त दबाव: $P = 2T/R$। साबुन के बुलबुले के अंदर (दो सतहें): $P = 4T/R$। तरल में हवा के बुलबुले के अंदर: $P = 2T/R$।',
            },
            {
              english: '**Capillary rise/fall:** $h = \\dfrac{2T \\cos\\theta}{\\rho g r}$ where $\\theta$ = angle of contact.',
        hindi: '**केशिका वृद्धि/गिरावट:** $h = \\dfrac{2T \\cos\\theta}{\\rho g r}$ जहां $\\theta$ = संपर्क का कोण।',
            },
            {
              english: 'Water-glass: $\\theta < 90°$ → rise. Mercury-glass: $\\theta > 90°$ → fall.',
        hindi: 'पानी का गिलास: $\\theta < 90°$ → वृद्धि। पारा-ग्लास: $\\theta > 90°$ → गिरना।',
            },
            {
              english: 'Surface tension decreases with temperature; vanishes at critical temperature.',
        hindi: 'तापमान के साथ सतह का तनाव कम हो जाता है; महत्वपूर्ण तापमान पर गायब हो जाता है।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: 'P = P_0 + \\rho g h',
      desc: {
        english: 'Hydrostatic',
        hindi: 'हीड्रास्टाटिक',
      },
    },
    {
      latex: 'F_B = \\rho_f V_{disp} g',
      desc: {
        english: 'Buoyancy',
        hindi: 'उछाल',
      },
    },
    {
      latex: 'A_1 v_1 = A_2 v_2',
      desc: {
        english: 'Continuity',
        hindi: 'निरंतरता',
      },
    },
    {
      latex: 'P + \\tfrac12 \\rho v^2 + \\rho g h = \\text{const}',
      desc: {
        english: 'Bernoulli',
        hindi: 'बर्नौली',
      },
    },
    {
      latex: 'v = \\sqrt{2gh}',
      desc: {
        english: 'Torricelli',
        hindi: 'टोरिसेली',
      },
    },
    {
      latex: 'v_t = 2 r^2 (\\rho - \\sigma) g / (9\\eta)',
      desc: {
        english: 'Terminal velocity',
        hindi: 'टर्मिनल वेग',
      },
    },
    {
      latex: 'h = 2T\\cos\\theta / (\\rho g r)',
      desc: {
        english: 'Capillary rise',
        hindi: 'केशिका वृद्धि',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'JEE Main',
      tag: 'Bernoulli',
      problem: {
        english: 'A tank has water $5$ m deep. Speed of efflux from a small hole at the base?',
        hindi: 'एक टैंक में पानी $5$ मीटर गहरा है। आधार पर एक छोटे से छेद से प्रवाह की गति?',
      },
      answer: {
        english: '$10$ m/s',
        hindi: '$10$ m/s',
      },
      solution: {
        english: '$v = \\sqrt{2 \\cdot 10 \\cdot 5} = 10$ m/s.',
        hindi: '$v = \\sqrt{2 \\cdot 10 \\cdot 5} = 10$ मी/से.',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Buoyancy',
      problem: {
        english: 'A wooden block of density $0.6$ g/cc floats in water. Fraction submerged?',
        hindi: '$0.6$ g/cc घनत्व का एक लकड़ी का ब्लॉक पानी में तैरता है। अंश जलमग्न?',
      },
      answer: {
        english: '$60\\%$',
        hindi: '$60\\\\%$',
      },
      solution: {
        english: 'Equal to ratio of densities.',
        hindi: 'घनत्व के अनुपात के बराबर।',
      },
    },
    {
      year: 2022,
      exam: 'JEE Main',
      tag: 'Stokes',
      problem: {
        english: 'Terminal velocity of a sphere is $v$. If radius is doubled (same fluid, same density), new terminal velocity?',
        hindi: 'एक गोले का अंतिम वेग $v$ है। यदि त्रिज्या दोगुनी कर दी जाए (समान द्रव, समान घनत्व), तो नया टर्मिनल वेग?',
      },
      answer: {
        english: '$4v$',
        hindi: '$4v$',
      },
      solution: {
        english: '$v_t \\propto r^2$.',
        hindi: '$v_t \\propto r^2$।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Surface tension',
      problem: {
        english: 'Excess pressure in a soap bubble of radius $1$ cm with $T = 0.03$ N/m?',
        hindi: '$T = 0.03$ N/m के साथ $1$ सेमी त्रिज्या वाले साबुन के बुलबुले में अतिरिक्त दबाव?',
      },
      answer: {
        english: '$12$ Pa',
        hindi: '$12$ पा',
      },
      solution: {
        english: '$P = 4T/R = 4(0.03)/0.01 = 12$ Pa.',
        hindi: '$P = 4T/R = 4(0.03)/0.01 = 12$ Pa.',
      },
    },
    {
      year: 2019,
      exam: 'JEE Main',
      tag: 'Continuity',
      problem: {
        english: 'Water flows through a horizontal pipe of varying cross-section. At a section of area $4$ cm², speed is $5$ m/s. At another section of $2$ cm², speed?',
        hindi: 'पानी अलग-अलग क्रॉस-सेक्शन के क्षैतिज पाइप से बहता है। $4$ सेमी² क्षेत्र के एक खंड पर, गति $5$ m/s है। $2$ सेमी² के दूसरे खंड पर, गति?',
      },
      answer: {
        english: '$10$ m/s',
        hindi: '$10$ m/s',
      },
      solution: {
        english: '$A_1 v_1 = A_2 v_2$.',
        hindi: '$A_1 v_1 = A_2 v_2$।',
      },
    },
  ],
  next: null,
};

export default chapter;
